import React from "react";
import PropTypes from "prop-types";
import { Form, Message } from "semantic-ui-react";
import { getSemanticProps } from "../../util";
import { getUiOptions } from "../../../../utils/getUiOptions";
import { SignatureCanvas } from "../../../../components/Signature/SignatureInput";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { useSignatureWidgetContext } from "../../../../context/SignatureContext";
import _select from "selectn";
import { useFormDataContext } from "../../../../context/FormDataContext";

function SignatureWidget({
  id,
  required,
  readonly,
  disabled,
  name,
  label,
  schema,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  formContext,
  uiSchema,
  rawErrors = [],
}: any) {

  const { t } = useSchemaTranslation();

  const signatureOptions = useSignatureWidgetContext();
  const formData = useFormDataContext();

  if (!signatureOptions) {
    return <Message content="Missing configurations for Signature widget" />
  }

  const { placeholder } = getUiOptions(uiSchema) as any;
  const semanticProps = getSemanticProps({ formContext, options });

  const signatoryPerson = options.signatoryFieldReference ? _select(options.signatoryFieldReference, formContext.currentFormData) : null;

  const signatoryName = signatoryPerson || options.signatoryName ? signatureOptions.renderSignatoryName({ personId: signatoryPerson, name: options.signatoryName }) : undefined;
  label = label || schema.title;

  return (
    <Form.Field key={id} required={required} disabled={readonly} >

      {label && <label>{t(label)} </label>}
      <SignatureCanvas
        onSaveSignature={signatureOptions.uploadSignature}
        renderSignature={signatureOptions.renderSignature}
        signatoryName={signatoryName}


        clearText={signatureOptions.clearText}
        acceptText={signatureOptions.acceptText}
        addSignatureText={signatureOptions.addSignatureText}
        addNewSignatureText={signatureOptions.addNewSignatureText}

        removeSignatureConfirmationText={signatureOptions.removeSignatureConfirmationText}
        signatureCannotBeEmptyText={signatureOptions.signatureCannotBeEmptyText}

      />
    </Form.Field>
  );
}

SignatureWidget.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

SignatureWidget.propTypes = {
  options: PropTypes.object,
};

export default SignatureWidget;
